import React, { FC, PropsWithChildren } from 'react';
import RcClickAway from 'react-click-away-listener';

import { ClickAwayListenerProps } from './interfaces';

const ClickAwayListener: FC<PropsWithChildren<ClickAwayListenerProps>> = ({
  onClickAway,
  children,
}) => {
  return (
    <RcClickAway mouseEvent="mousedown" onClickAway={() => onClickAway?.()}>
      <div className="clickAwayListener">{children}</div>
    </RcClickAway>
  );
};

export default ClickAwayListener;
